import { UrlConstants } from "../url.constants";
export class ApiGautrainConstants {
    static URL = UrlConstants.API_V2 + "Gautrain";
    static FUNCTION_SET_ZONES = "SetGautrainZones";
    static FUNCTION_SET_APPLICATION_TYPES = "SetGautrainApplicationTypes";
    static FUNCTION_GET_DISTINCT_APPLICATION_TYPES = "GetDistinctApplicationTypes";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetGautrainApplicantAndApplicantAgent";
    static FUNCTION_SET_PROPERTIES = "SetProperties";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateGautrainInvoiceReport";
    static FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST = "GetGautrainRequiredDocumentsChecklist";
    static FUNCTION_GET_EXTERNAL_LINKS = "GetExternalLinks";
    static FUNCTION_APPLICATION_TYPES = "SetGautrainApplicationTypes";
}
